import React from 'react';
import { createWebRendererUrl } from 'react-cosmos-core';
import { Slot } from 'react-plugin';
import styled from 'styled-components';
import { grey8 } from '../../style/colors.js';
import { RemoteRendererOverlay } from './RendererOverlay/RemoteRendererOverlay.js';
import { RendererOverlay } from './RendererOverlay/RendererOverlay.js';
export const RendererPreview = React.memo(function RendererPreview({ rendererUrl, rendererConnected, runtimeStatus, backgroundColor, onIframeRef, }) {
    if (!rendererUrl) {
        // This code path is used when Cosmos is in React Native mode
        return (React.createElement(Container, { style: { backgroundColor: grey8 } },
            React.createElement(RemoteRendererOverlay, { rendererConnected: rendererConnected })));
    }
    return (React.createElement(Slot, { name: "rendererPreviewOuter" },
        React.createElement(Container, { style: { backgroundColor } },
            React.createElement(Iframe, { "data-testid": "previewIframe", ref: onIframeRef, src: createWebRendererUrl(rendererUrl), allow: "clipboard-write *; fullscreen *;" }),
            React.createElement(RendererOverlay, { runtimeStatus: runtimeStatus }))));
});
const Container = styled.div `
  position: relative;
  width: 100%;
  height: 100%;
`;
const Iframe = styled.iframe `
  display: block;
  width: 100%;
  height: 100%;
  margin: 0;
  padding: 0;
  border: 0;
  color-scheme: normal;
`;
